export function SubmitResend()
{
    return({
        type:"SUBMIT_ADD_RESEND"
    })
}